import React from "react";
import { Award, Clock, Heart, Users } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WhyChooseAlignPhysiotherapy() {
  const benefits = [{
    id: 1,
    icon: Award,
    title: "Evidence-Based Care",
    description: "Treatment plans built on the latest clinical research and proven techniques for effective recovery."
  }, {
    id: 2,
    icon: Users,
    title: "Expert Team",
    description: "Experienced physiotherapists specialising in musculoskeletal conditions with over 20 years of expertise."
  }, {
    id: 3,
    icon: Heart,
    title: "Personalised Approach",
    description: "Tailored care plans designed around your individual needs, goals, and lifestyle."
  }, {
    id: 4,
    icon: Clock,
    title: "Flexible Scheduling",
    description: "Convenient appointment times Monday to Saturday, fitting seamlessly into your busy life."
  }];
  return <section className="bg-background py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4 tracking-wide">
            Why Choose Align Physiotherapy?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto leading-[1.6]">
            At Align Physiotherapy, we combine clinical expertise with compassionate care to help you move better, feel better, and get back to doing what you love.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 mb-12">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <Card key={benefit.id} data-index={i} className="bg-white border border-border shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] animate-fade-in-up-delay-100">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-display font-semibold text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm text-muted-foreground leading-[1.6]">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="text-center animate-fade-in-up-delay-200">
          <Link to="/ServicesPage">
            <Button size="lg" className="bg-primary text-primary-foreground font-semibold px-8 py-3 rounded-lg shadow-soft hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0 transition-all duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
              Explore Our Services
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}